import React from 'react';

import { StoreListingPersonalizedPricingEmptyState } from '../../../components/store-listings/StoreListingPersonalizedPricingEmptyState';

export function PersonalizedPaymentSettings() {
  return <StoreListingPersonalizedPricingEmptyState />;
}
